export default __webpack_public_path__ + "media/zurb/img/design-systems/style_guide-e8ce61756a691a8f0a0e9c98f5ed4449.png";